import KunLoading94 from './src/index'

KunLoading94.install = function (Vue) {
	Vue.component(KunLoading94.name, KunLoading94);
}

export default KunLoading94;
